import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  selectPartner360Files,
  selectPartner360Uid,
  selectPartnerAccess,
} from 'legacy/lut/features/partner360/configuration'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button, IButtonProps } from 'core-components/library/button'
import { PartnerCommitmentTranslations } from 'partner360/entities/partnerCompleteness'

import { downloadPartnerPlan } from './api/downloadPartnerPlan'
import { EXPORT_EXTENSION } from './configs'

interface IDownloadPartnerPlanProps {
  buttonTranslation?: string
  className?: string
  programType: ProgramTypes
  buttonVariant?: IButtonProps['variant']
  buttonColor?: IButtonProps['color']
  buttonSize?: IButtonProps['size']
}

export const DownloadPartnerPlanButton: FC<IDownloadPartnerPlanProps> = ({
  buttonTranslation = PartnerCommitmentTranslations.DownloadPartnerPlan,
  className,
  programType,
  buttonVariant,
  buttonColor,
  buttonSize,
}) => {
  const uid = useSelector(selectPartner360Uid)
  const files = useSelector(selectPartner360Files)
  const { isDistributor, isRetail } = useSelector(selectPartnerAccess)

  const downloadHandler = useCallback(async () => {
    if (uid) {
      await downloadPartnerPlan({
        uid,
        files,
        programType,
        isDistributor,
        isRetail,
        exportFormat: EXPORT_EXTENSION,
      })
    }
  }, [programType, isDistributor, isRetail, uid, files])

  return (
    <Button
      disabled={!uid}
      className={className}
      onClick={downloadHandler}
      variant={buttonVariant}
      color={buttonColor}
      size={buttonSize}
    >
      <Translation text={buttonTranslation} />
    </Button>
  )
}
